import script from "./SMSLogsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SMSLogsModal.vue?vue&type=script&lang=ts&setup=true"

import "./SMSLogsModal.vue?vue&type=style&index=0&id=11db4800&scoped=true&lang=scss"
import "./SMSLogsModal.vue?vue&type=style&index=1&id=11db4800&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11db4800"]])

export default __exports__